
export default function CompanyStorySection() {
  return (
    <section className="py-16 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            品牌故事
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            从传统到创新，我们始终坚持品质第一
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左侧图片 */}
          <div className="order-2 lg:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/6916e0c80f12b3250bb9933b909d21cc.jpg"
              alt="品牌故事"
              className="w-full h-full object-cover object-top rounded-2xl shadow-lg"
            />
          </div>

          {/* 右侧内容 */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="space-y-4">
              <h3 className="text-lg sm:text-xl font-bold text-[#663333]">传承与创新的完美结合</h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                顺年陈成立于2015年，由一群热爱茶文化的专业人士创立。我们深入云南核心茶区，与当地500多家藏茶厂和茶农建立了长期合作关系，从源头把控茶叶品质。
              </p>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                经过多年的发展，我们建立了完善的"三真"承诺体系：真产地、真年份、真转化。通过透明化的管理流程和数据化的品质标准，为消费者提供最可靠的年份茶产品。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-4 bg-[#f5f5f5] rounded-lg">
                <div className="text-lg sm:text-xl font-bold text-[#663333] mb-2">2015</div>
                <div className="text-xs sm:text-sm text-gray-600">品牌创立</div>
              </div>
              <div className="text-center p-4 bg-[#f5f5f5] rounded-lg">
                <div className="text-lg sm:text-xl font-bold text-[#663333] mb-2">500+</div>
                <div className="text-xs sm:text-sm text-gray-600">合作伙伴</div>
              </div>
              <div className="text-center p-4 bg-[#f5f5f5] rounded-lg">
                <div className="text-lg sm:text-xl font-bold text-[#663333] mb-2">60,000㎡</div>
                <div className="text-xs sm:text-sm text-gray-600">仓储面积</div>
              </div>
              <div className="text-center p-4 bg-[#f5f5f5] rounded-lg">
                <div className="text-lg sm:text-xl font-bold text-[#663333] mb-2">全国第一</div>
                <div className="text-xs sm:text-sm text-gray-600">年份茶销量</div>
              </div>
            </div>
          </div>
        </div>

        {/* 发展历程 */}
        <div className="mt-16">
          <h3 className="text-lg sm:text-xl font-bold text-[#663333] text-center mb-12">发展历程</h3>
          
          <div className="relative">
            {/* 时间线 - 桌面版 */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-[#cc9966] hidden lg:block"></div>
            
            {/* 时间线 - 移动版 */}
            <div className="absolute left-6 top-0 w-1 h-full bg-[#cc9966] lg:hidden"></div>
            
            <div className="space-y-12">
              {/* 2015年 */}
              <div className="flex flex-col lg:flex-row items-center">
                {/* 桌面版布局 */}
                <div className="lg:w-1/2 lg:pr-8 text-right mb-4 lg:mb-0 hidden lg:block">
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-2">2015年 - 品牌创立</h4>
                    <p className="text-xs sm:text-sm text-gray-600">
                      顺年陈品牌正式成立，开始专注于年份茶的收藏与销售
                    </p>
                  </div>
                </div>
                
                {/* 年份圆圈 */}
                <div className="relative z-10 w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center text-white font-bold mb-4 lg:mb-0 text-xs lg:mx-0 ml-0">
                  2015
                </div>
                
                {/* 移动版内容 */}
                <div className="w-full pl-8 lg:hidden">
                  <div className="bg-white p-4 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm font-bold text-[#663333] mb-2">2015年 - 品牌创立</h4>
                    <p className="text-xs text-gray-600">
                      顺年陈品牌正式成立，开始专注于年份茶的收藏与销售
                    </p>
                  </div>
                </div>
                
                <div className="lg:w-1/2 lg:pl-8 hidden lg:block"></div>
              </div>

              {/* 2018年 */}
              <div className="flex flex-col lg:flex-row items-center">
                <div className="lg:w-1/2 lg:pr-8 hidden lg:block"></div>
                
                {/* 年份圆圈 */}
                <div className="relative z-10 w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center text-white font-bold mb-4 lg:mb-0 text-xs lg:mx-0 ml-0">
                  2018
                </div>
                
                {/* 桌面版内容 */}
                <div className="lg:w-1/2 lg:pl-8 text-left mb-4 lg:mb-0 hidden lg:block">
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-2">2018年 - 标准建立</h4>
                    <p className="text-xs sm:text-sm text-gray-600">
                      建立"三真"承诺体系，制定年份茶行业标准
                    </p>
                  </div>
                </div>
                
                {/* 移动版内容 */}
                <div className="w-full pl-8 lg:hidden">
                  <div className="bg-white p-4 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm font-bold text-[#663333] mb-2">2018年 - 标准建立</h4>
                    <p className="text-xs text-gray-600">
                      建立"三真"承诺体系，制定年份茶行业标准
                    </p>
                  </div>
                </div>
              </div>

              {/* 2020年 */}
              <div className="flex flex-col lg:flex-row items-center">
                {/* 桌面版布局 */}
                <div className="lg:w-1/2 lg:pr-8 text-right mb-4 lg:mb-0 hidden lg:block">
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-2">2020年 - 销量突破</h4>
                    <p className="text-xs sm:text-sm text-gray-600">
                      年份茶销量突破全国第一，获得尚普咨询权威认证
                    </p>
                  </div>
                </div>
                
                {/* 年份圆圈 */}
                <div className="relative z-10 w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center text-white font-bold mb-4 lg:mb-0 text-xs lg:mx-0 ml-0">
                  2020
                </div>
                
                {/* 移动版内容 */}
                <div className="w-full pl-8 lg:hidden">
                  <div className="bg-white p-4 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm font-bold text-[#663333] mb-2">2020年 - 销量突破</h4>
                    <p className="text-xs text-gray-600">
                      年份茶销量突破全国第一，获得尚普咨询权威认证
                    </p>
                  </div>
                </div>
                
                <div className="lg:w-1/2 lg:pl-8 hidden lg:block"></div>
              </div>

              {/* 2023年 */}
              <div className="flex flex-col lg:flex-row items-center">
                <div className="lg:w-1/2 lg:pr-8 hidden lg:block"></div>
                
                {/* 年份圆圈 */}
                <div className="relative z-10 w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center text-white font-bold mb-4 lg:mb-0 text-xs lg:mx-0 ml-0">
                  2023
                </div>
                
                {/* 桌面版内容 */}
                <div className="lg:w-1/2 lg:pl-8 text-left mb-4 lg:mb-0 hidden lg:block">
                  <div className="bg-white p-6 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-2">2023年 - 荣誉加身</h4>
                    <p className="text-xs sm:text-sm text-gray-600">
                      荣获国宾伴手礼认证，七星茶王奖等多项殊荣
                    </p>
                  </div>
                </div>
                
                {/* 移动版内容 */}
                <div className="w-full pl-8 lg:hidden">
                  <div className="bg-white p-4 rounded-xl shadow-lg border border-[#cc9966]/20">
                    <h4 className="text-sm font-bold text-[#663333] mb-2">2023年 - 荣誉加身</h4>
                    <p className="text-xs text-gray-600">
                      荣获国宾伴手礼认证，七星茶王奖等多项殊荣
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
